<script setup>
// Admin Home "Players to place" (JOIN_SETTINGS_PLAN.md D19): beside the approvals card,
// one row per competition with waiting players and a Place link into its waiting card.
defineProps({
  count: {type: Number, default: 0},
  // TimelinePendingPlacementCompetitionResponse[]
  competitions: {type: Array, default: () => []},
});

const icon = (type) => ({1: 'mdi-ladder', 2: 'mdi-table', 6: 'mdi-account-switch'}[type] ?? 'mdi-account-clock-outline');
const rowSub = (c) => {
  const parts = [c.clubName, c.waitingCount === 1 ? '1 waiting' : `${c.waitingCount} waiting`];
  if (c.suggestedGroupCount > 0) parts.push(c.suggestedGroupCount === 1 ? '1 pair ready' : `${c.suggestedGroupCount} pairs ready`);
  return parts.filter(Boolean).join(' · ');
};
</script>

<template>
  <div v-if="count > 0" class="tl-card psc mb-3">
    <div class="tl-attention psc-head">
      <v-avatar size="42" color="warningTint">
        <v-icon color="warning">mdi-account-clock-outline</v-icon>
      </v-avatar>
      <div class="tl-attention-who">
        <div class="tl-attention-title">
          {{ count === 1 ? '1 player waiting to be placed' : `${count} players waiting to be placed` }}
        </div>
        <div class="tl-attention-sub">They've joined. Pick their team, division or seat</div>
      </div>
    </div>
    <router-link v-for="c in competitions" :key="c.id" class="psc-row" :to="c.path + '?place=1'">
      <div class="psc-row-ic"><v-icon size="18" :icon="icon(c.referenceType)"/></div>
      <div class="flex-fill min-w-0">
        <div class="psc-row-title">{{ c.name }}</div>
        <div class="psc-row-sub">{{ rowSub(c) }}</div>
      </div>
      <span class="psc-row-cta">Place<v-icon size="16" icon="mdi-chevron-right"/></span>
    </router-link>
  </div>
</template>

<style scoped lang="scss">
.psc {
  overflow: hidden;
}

.tl-attention {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;

  .tl-attention-who {
    flex: 1 1 auto;
    min-width: 0;
  }

  .tl-attention-title {
    font-size: 13.5px;
    font-weight: 600;
    line-height: 1.3;
  }

  .tl-attention-sub {
    font-size: 11.5px;
    color: rgb(var(--v-theme-textSubtle));
    margin-top: 1px;
  }
}

.psc-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-top: 1px solid rgb(var(--v-theme-borderLight));
  color: inherit;
  text-decoration: none;

  &:hover {
    background: rgb(var(--v-theme-light));
  }
}

.psc-row-ic {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgb(var(--v-theme-light));
  border: 1px solid rgb(var(--v-theme-borderLight));
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(var(--v-theme-charcoal));
  flex-shrink: 0;
}

.psc-row-title {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.psc-row-sub {
  font-size: 11.5px;
  color: rgb(var(--v-theme-textSubtle));
}

.psc-row-cta {
  display: inline-flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 700;
  color: rgb(var(--v-theme-primary));
  flex-shrink: 0;
}
</style>
